"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clip = exports.renderingDuration = exports.totalPatternDuration = exports.recursivelyApplyPatternToDurations = exports.getDuration = exports.getNote = void 0;
var utils_1 = require("./utils");
// import { window } from './window';
// if (!(window as any).Tone) {
//   (window as any).Tone = Tone;
// }
// const tone = (window as any).Tone;
// const tone = Tone || (window as any).Tone;
var defaultSubdiv = '4n';
var defaultDur = '8n';
/**
 * Get default params for a clip, such as root note, pattern etc
 * @return {Object}
 */
var getDefaultParams = function () { return ({
    notes: ['C4'],
    pattern: 'x',
    shuffle: false,
    sizzle: false,
    sizzleReps: 1,
    arpegiate: false,
    subdiv: '4n',
    align: '1m',
    alignOffset: '0',
    amp: 100,
    accentLow: 70,
    randomNotes: null,
    offlineRendering: false,
}); };
/* UNUSED *
 * HDR speed is denoted by the number of ticks per note
 * By default this is set to a quarter note (4n) to be in line with Tone.js' default subdivision
 * Technically a bar is 512 ticks long. So it's HDR speed is 512
 * @type {Object}
 * /
const hdr: NVP<number> = {
  '1m': 2048,
  '2m': 4096,
  '3m': 6144,
  '4m': 8192,
  '1n': 512,
  '2n': 256,
  '4n': 128,
  '8n': 64,
  '16n': 32,
};
/* */
var getNote = function (el, params, counter) {
    if (el === 'R' && params.randomNotes && params.randomNotes.length > 0) {
        return params.randomNotes[(0, utils_1.randomInt)(params.randomNotes.length - 1)];
    }
    if (params.notes) {
        return params.notes[counter % (params.notes.length || 1)];
    }
    return '';
};
exports.getNote = getNote;
var getDuration = function (params, counter) {
    return params.durations
        ? params.durations[counter % params.durations.length]
        : params.dur || params.subdiv || defaultDur;
};
exports.getDuration = getDuration;
var recursivelyApplyPatternToDurations = function (patternArr, length, durations) {
    if (durations === void 0) { durations = []; }
    patternArr.forEach(function (char) {
        if (typeof char === 'string') {
            if (char === 'x' || char === 'R') {
                durations.push(length);
            }
            if (char === '_' && durations.length) {
                durations[durations.length - 1] += length;
            }
        }
        if (Array.isArray(char)) {
            (0, exports.recursivelyApplyPatternToDurations)(char, length / char.length, durations);
        }
    });
    return durations;
};
exports.recursivelyApplyPatternToDurations = recursivelyApplyPatternToDurations;
var generateSequence = function (params, channel, context) {
    context = context || Tone.getContext();
    if (!params.pattern) {
        throw new Error('No pattern provided!');
    }
    if (!params.durations && !params.dur) {
        params.durations = (0, exports.recursivelyApplyPatternToDurations)((0, utils_1.expandStr)(params.pattern), Tone.Ticks(params.subdiv || defaultSubdiv).toSeconds());
    }
    return new Tone.Sequence({
        callback: channel.getSeqFn(params),
        events: (0, utils_1.expandStr)(params.pattern),
        subdivision: params.subdiv || defaultSubdiv,
        context: context,
    });
};
var totalPatternDuration = function (pattern, subdivOrLength) {
    return typeof subdivOrLength === 'number'
        ? subdivOrLength * (0, utils_1.expandStr)(pattern).length
        : Tone.Ticks(subdivOrLength).toSeconds() * (0, utils_1.expandStr)(pattern).length;
};
exports.totalPatternDuration = totalPatternDuration;
var leastCommonMultiple = function (n1, n2) {
    var _a = n1 < n2 ? [n1, n2] : [n2, n1], smallest = _a[0], largest = _a[1];
    var i = largest;
    while (i % smallest !== 0) {
        i += largest;
    }
    return i;
};
var renderingDuration = function (pattern, subdivOrLength, notes, randomNotes) {
    var patternRegularNotesCount = pattern.split('').filter(function (c) {
        return c === 'x';
    }).length;
    var patternRandomNotesCount = pattern.split('').filter(function (c) {
        return c === 'R';
    }).length;
    var patternNotesCount = (randomNotes === null || randomNotes === void 0 ? void 0 : randomNotes.length)
        ? patternRegularNotesCount
        : patternRegularNotesCount + patternRandomNotesCount;
    var notesCount = notes.length || 1;
    return (((0, exports.totalPatternDuration)(pattern, subdivOrLength) / patternNotesCount) *
        leastCommonMultiple(notesCount, patternNotesCount));
};
exports.renderingDuration = renderingDuration;
var ongoingRenderingCounter = 0;
var originalContext;
var offlineRenderClip = function (params, duration) {
    if (!originalContext) {
        originalContext = Tone.getContext();
    }
    ongoingRenderingCounter++;
    var player = new Tone.Player({ context: originalContext, loop: true });
    Tone.Offline(function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var sequence;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sequence = generateSequence(params, context);
                    return [4 /*yield*/, Tone.loaded()];
                case 1:
                    _a.sent();
                    sequence.start();
                    context.transport.start();
                    return [2 /*return*/];
            }
        });
    }); }, duration).then(function (buffer) {
        var _a;
        player.buffer = buffer;
        ongoingRenderingCounter--;
        if (ongoingRenderingCounter === 0) {
            Tone.setContext(originalContext);
            (_a = params.offlineRenderingCallback) === null || _a === void 0 ? void 0 : _a.call(params);
        }
    });
    player.toDestination();
    player.sync();
    return player;
};
/**
 * @param  {Object}
 * @return {Tone.js Sequence Object}
 * Take a object literal that may have a Tone.js player OR instrument
 * or simply a sample or synth with a pattern and return a Tone.js sequence
 */
var clip = function (params, channel) {
    params = __assign(__assign({}, getDefaultParams()), (params || {}));
    // If notes is a string, split it into an array
    if (typeof params.notes === 'string') {
        // Remove any accidental double spaces
        params.notes = params.notes.replace(/\s{2,}/g, ' ');
        params.notes = params.notes.split(' ');
    }
    params.notes = params.notes ? params.notes.map(utils_1.convertChordsToNotes) : [];
    if (/[^x\-_[\]R]/.test(params.pattern)) {
        throw new TypeError("pattern can only comprise x - _ [ ] R, found " + params.pattern);
    }
    if (params.shuffle) {
        params.notes = (0, utils_1.shuffle)(params.notes);
    }
    if (params.randomNotes && typeof params.randomNotes === 'string') {
        params.randomNotes = params.randomNotes.replace(/\s{2,}/g, ' ').split(/\s/);
    }
    if (params.randomNotes) {
        params.randomNotes = params.randomNotes.map(utils_1.convertChordsToNotes);
    }
    if (params.offlineRendering) {
        return offlineRenderClip(params, (0, exports.renderingDuration)(params.pattern, params.subdiv || defaultSubdiv, params.notes, params.randomNotes));
    }
    return generateSequence(params, channel, originalContext);
};
exports.clip = clip;
